import React, { useState, useEffect } from "react";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import UserManagement from "./components/UserManagement";
import LeadsManagement from "./components/LeadsManagement";
import ConfigManagement from "./components/ConfigManagement";
import LogManagements from "./components/LogManagements";
import apiService from "./services/api";
import {
    Home,
    Users,
    Target,
    Settings,
    Terminal,
    LogOut,
    Menu,
    X
} from 'lucide-react';

function App() {
    const [authenticated, setAuthenticated] = useState(false);
    const [activeTab, setActiveTab] = useState('dashboard');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAuthStatus();

        // Listen for navigation events from components
        const handleNavigate = (event) => {
            setActiveTab(event.detail.tab);
            setSidebarOpen(false);
        };

        window.addEventListener('navigate', handleNavigate);
        return () => window.removeEventListener('navigate', handleNavigate);
    }, []);

    const checkAuthStatus = async () => {
        const token = localStorage.getItem('authToken');
        if (!token) {
            setLoading(false);
            return;
        }

        try {
            await apiService.verifyAuth();
            setAuthenticated(true);
        } catch (error) {
            localStorage.removeItem('authToken');
            setAuthenticated(false);
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = () => {
        setAuthenticated(true);
    };

    const handleLogout = async () => {
        try {
            await apiService.logout();
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            setAuthenticated(false);
            setActiveTab('dashboard');
        }
    };

    const navigationItems = [
        { id: 'dashboard', label: 'Dashboard', icon: Home },
        { id: 'users', label: 'Users', icon: Users },
        { id: 'leads', label: 'Leads', icon: Target },
        { id: 'logs', label: 'Logs', icon: Terminal },
        { id: 'config', label: 'Configuration', icon: Settings },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':
                // return <Dashboard />
                return (
                    <div className="container md:max-w-screen-lg mx-auto flex flex-col gap-12">
                        {/* <Dashboard /> */}
                        <LogManagements />
                        <ConfigManagement />
                    </div>);
            case 'users':
                return <UserManagement />;
            case 'leads':
                return <LeadsManagement />;
            case 'logs':
                return <LogManagements />;
            case 'config':
                return <ConfigManagement />;
            default:
                return <ConfigManagement />;
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!authenticated) {
        return <Login onLogin={handleLogin} />;
    }

    return (
        <div className="min-h-screen bg-gray-50 flex">
            {/* Sidebar */}
            {/* <div className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'
                } fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0`}>
                <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
                    <h1 className="text-xl font-bold text-blue-700">Lead Claimer</h1>
                    <button
                        onClick={() => setSidebarOpen(false)}
                        className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-600"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <nav className="mt-8">
                    <div className="px-4 space-y-2">
                        {navigationItems.map((item) => {
                            const Icon = item.icon;
                            return (
                                <button
                                    key={item.id}
                                    onClick={() => {
                                        setActiveTab(item.id);
                                        setSidebarOpen(false);
                                    }}
                                    className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-colors ${activeTab === item.id
                                            ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                        }`}
                                >
                                    <Icon className="w-5 h-5 mr-3" />
                                    {item.label}
                                </button>
                            );
                        })}
                    </div>

                    <div className="mt-8 pt-8 border-t border-gray-200">
                        <div className="px-4">
                            <button
                                onClick={handleLogout}
                                className="w-full flex items-center px-4 py-3 text-left rounded-lg text-red-600 hover:bg-red-50 transition-colors"
                            >
                                <LogOut className="w-5 h-5 mr-3" />
                                Logout
                            </button>
                        </div>
                    </div>
                </nav>
            </div> */}

            {/* Main Content */}
            <div className="flex-1 lg:ml-0">
                {/* Header */}
                <header className="bg-white shadow-sm border-b border-gray-200">
                    <div className="flex items-center justify-between h-16 px-6">
                        <button
                            onClick={() => setSidebarOpen(true)}
                            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-600"
                        >
                            <Menu className="w-5 h-5" />
                        </button>

                        <div className="flex items-center">
                            <h1 className="text-xl font-bold text-blue-700">Lead Claimer Control Panel</h1>
                        </div>
                        {/* <div className="flex items-center">
              <h2 className="text-lg font-semibold text-gray-900 capitalize">
                {navigationItems.find(item => item.id === activeTab)?.label || 'Dashboard'}
              </h2>
            </div> */}

                        <div className="flex items-center space-x-4">
                            <span className="text-sm text-gray-500">Admin</span>
                            <button
                                onClick={handleLogout}
                                className="p-2 rounded-md text-gray-400 hover:text-gray-600"
                                title="Logout"
                            >
                                <LogOut className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </header>

                {/* Page Content */}
                <main className="p-6">
                    {renderContent()}
                </main>
            </div>

            {/* Overlay for mobile sidebar */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}
        </div>
    );
}

export default App;
